"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteType = void 0;
exports.noteTypeForEditorIdentifier = noteTypeForEditorIdentifier;
const Features_1 = require("../Feature/Features");
var NoteType;
(function (NoteType) {
    NoteType["Authentication"] = "authentication";
    NoteType["Code"] = "code";
    NoteType["Markdown"] = "markdown";
    NoteType["RichText"] = "rich-text";
    NoteType["Spreadsheet"] = "spreadsheet";
    NoteType["Task"] = "task";
    NoteType["Plain"] = "plain-text";
    NoteType["Super"] = "super";
    NoteType["Unknown"] = "unknown";
})(NoteType || (exports.NoteType = NoteType = {}));
function noteTypeForEditorIdentifier(identifier) {
    const feature = (0, Features_1.FindNativeFeature)(identifier);
    if (feature && feature.note_type) {
        return feature.note_type;
    }
    return NoteType.Unknown;
}
